<template>
  <div class="ui middle aligned center aligned grid">
    <div class="column" v-if="showForm">
      <div class="ui success message" v-if="showSuccessMessage">
        <p>{{ $t('pages.register.form.success') }}</p>
        <router-link :to="{name: 'usersetup'}">{{ $t('pages.register.redirectlink') }}</router-link>
      </div>
      <div class="ui blue header centered">
        <div class="content">
          {{ $t('pages.register.header') }}
        </div>
      </div>
      <form class="ui large form" @submit.prevent="sendForm">
        <div class="ui stacked segment">
          <div class="field" :class="{ 'error' : errors.has('email') }">
            <div class="ui input">
              <input type="email" v-model="email" :data-vv-as="$t('pages.register.form.email')" name="email"
                     :placeholder="$t('pages.register.form.email')" v-validate="'required|email'" readonly>
            </div>
            <span style="color:red;" v-if="errors.has('email')">{{ errors.first('email') }}</span>
          </div>

          <div class="field" :class="{ 'error' : errors.has('password') }">
            <div class="ui input">
              <input type="password" v-model="password" ref="passwordRef"
                     :data-vv-as="$t('pages.register.form.password')" name="password"
                     :placeholder="$t('pages.register.form.password')" v-validate="'required'">
            </div>
            <span style="color:red;" v-if="errors.has('password')">{{ errors.first('password') }}</span>
          </div>

          <div class="field" :class="{ 'error' : errors.has('password_confirmation') }">
            <div class="ui input">
              <input type="password" v-model="password_confirmation"
                     :data-vv-as="$t('pages.register.form.password_confirmation')" name="password_confirmation"
                     :placeholder="$t('pages.register.form.password_confirmation')"
                     v-validate="'required|confirmed:passwordRef'">
            </div>
            <span style="color:red;" v-if="errors.has('password_confirmation')">{{
                errors.first('password_confirmation')
              }}</span>
          </div>

          <div class="field" :class="{ 'error' : errors.has('terms') }">
            <div class="ui checkbox">
              <input name="terms" v-model="acceptingTerms" :data-vv-as="$t('pages.register.form.termsandconds')"
                     type="checkbox" v-validate="'required'">
              <label>{{ $t('pages.register.form.i_accept') }} <a @click.prevent="showTerms = !showTerms" href="#">{{
                  $t('pages.register.form.termsandconds')
                }}</a></label>
              <span style="color: red;" v-if="errors.has('terms')">{{ errors.first('terms') }}</span>
            </div>
          </div>

          <button type="submit" class="ui large fluid blue button" :disabled="errors.any()">
            {{ $t('pages.register.form.button') }}
          </button>
        </div>
      </form>
    </div>

    <semantic-modal v-model="showTerms"
                    :settings="{content_classes: {content: true}, closeable: false, closeable_button: false}"
                    class="large">
      <div class="ui header" slot="header">
        {{ $t('modals.termsandconds.accept_header') }}
      </div>
      <user-terms></user-terms>
      <div class="actions" slot="actions">
        <div class="ui red deny button" @click="acceptingTerms = false">{{ $t('globals.buttons.no') }}</div>
        <div class="ui ok green button" @click="acceptingTerms = true">{{ $t('globals.buttons.accept') }}</div>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import size from 'lodash/size'

export default {
  name: 'RegisterUser',

  layout: 'default',

  data() {
    return {
      showForm: false,
      email: '',
      password: '',
      password_confirmation: '',
      acceptingTerms: false,
      showTerms: false,

      token: this.$route.params.token ? this.$route.params.token : null,

      showSuccessMessage: false,
      waitBeforeRedirect: 1800
    }
  },

  mounted() {
    if (size(this.$auth.user()) > 0) {
      this.$auth.logout({
        makeRequest: true,
        redirect: false
      })
    }

    this.checkToken()
      .then(result => {
        this.showForm = true
        this.email = result.email

        if (size(this.$auth.user()) > 0) {
          this.$auth.logout({
            makeRequest: true,
            redirect: false
          })
        }
      }).catch(() => {
      this.$router.push('/')
      this.showForm = false
    })
  },

  methods: {
    checkToken() {
      return new Promise((resolve, reject) => {
        this.axios.get(`check-email/${this.token}`)
          .then(({data}) => {
            resolve(data)
          }).catch(error => {
          reject(error)
        })
      })
    },

    sendForm() {
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            // send post request
            this.axios.post('/update-password', {
              email: this.email,
              password: this.password,
              password_confirmation: this.password_confirmation,
              token: this.token
            })
              .then(({data}) => {
                if (data.success) {
                  this.showSuccessMessage = true

                  this.$auth.login({
                    data: {
                      email: this.email,
                      password: this.password
                    },
                    rememberMe: true,
                    redirect: {name: 'usersetup', params: {process: 'get-started'}},
                    fetchUser: true,
                    success() {
                      this.$store.dispatch('fetchMerchants').then(() => {
                        if (this.$store.getters.Merchants.data.length > 0) {
                          this.fetchActiveMerchant(this.$store.getters.Merchants.data[0].id)
                        }
                      })
                    }
                  })
                }
              }).catch(error => {
              const _this = this

              $.map(error.response.data.errors, function (item, index) {
                _this.errors.add({
                  field: index,
                  msg: item[0]
                })
              })
            })
          }
        }).catch()
    },

    fetchActiveMerchant(id) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('fetchMerchant', id).then(() => {
          // return active merchant
          resolve(this.$store.getters.activeMerchant)
        }, error => {
          reject(error)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ui.middle.aligned.center.aligned.grid {
  height: 100vh;
  width: 100%;
  justify-content: center;
}

.ui.middle.aligned.center.aligned.grid > .column {
  width: 450px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/UserRegistration.vue